import * as i0 from '@angular/core';
import { EventEmitter, Component, Inject, Optional, Self, Input, Output, NgModule } from '@angular/core';
import * as i2 from '@fgb/core';
import { DEFAULT_COUNTRY } from '@fgb/core';
import * as i1 from '@angular/forms';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@ngx-translate/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

class SelectCountryComponent {
    constructor(defaultCountry, ngControl, countryService, countryQuery) {
        this.defaultCountry = defaultCountry;
        this.ngControl = ngControl;
        this.countryService = countryService;
        this.countryQuery = countryQuery;
        this.onChangeCallback = (_) => { };
        this.onTouchedCallback = () => { };
        this.innerValue = '';
        this.countryChange = new EventEmitter();
        if (this.ngControl)
            this.ngControl.valueAccessor = this;
    }
    ngOnInit() {
        if (this.ngControl) {
            this.control = this.ngControl.control;
            this.control.updateValueAndValidity();
        }
        this.countryService.fetchCountries().toPromise().then(() => {
            if (this.ngControl) {
                // Set the default value if the control is not set
                const value = this.innerValue || this.defaultCountry;
                // Update to emit the country change event
                this.writeValue(value);
            }
        });
    }
    writeValue(value) {
        this.innerValue = value;
        this.onChangeCallback(this.innerValue);
        const country = this.countries.find(country => country.CountryName === value);
        setTimeout(() => this.countryChange.emit(country));
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    get countries() {
        return this.countryQuery.getAll().sort(this._sort());
    }
    _sort() {
        return (a, b) => {
            if (a.Ordinal < b.Ordinal) {
                return -1;
            }
            else if (a.Ordinal > b.Ordinal) {
                return 1;
            }
            else if (a.Ordinal === b.Ordinal) {
                return a.DisplayName.localeCompare(b.DisplayName);
            }
            return 0;
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCountryComponent, deps: [{ token: DEFAULT_COUNTRY }, { token: i1.NgControl, optional: true, self: true }, { token: i2.CountryService }, { token: i2.CountryQuery }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SelectCountryComponent, selector: "fgbcl-select-country", inputs: { label: "label" }, outputs: { countryChange: "countryChange" }, ngImport: i0, template: "<div class=\"form-floating\">\r\n  <select\r\n    id=\"select-country\"\r\n    class=\"form-select\"\r\n    [class.invalid]=\"!control?.valid && control?.touched\"\r\n    name=\"Country\"\r\n    (change)=\"writeValue($event.target.value)\"\r\n  >\r\n    <option value=\"\" selected hidden>\r\n      {{ 'country.options.none.selected' | translate: { fgbdefault: '--Select--' } }}\r\n    </option>\r\n    <option *ngFor=\"let country of countries\" [value]=\"country.CountryName\" [selected]=\"country.CountryName === innerValue\">\r\n      {{ country.DisplayName }}\r\n    </option>\r\n  </select>\r\n  <label for=\"select-country\" *ngIf=\"label\">{{ label }}</label>\r\n</div>\r\n", styles: [":host{width:inherit}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i4.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCountryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-select-country', template: "<div class=\"form-floating\">\r\n  <select\r\n    id=\"select-country\"\r\n    class=\"form-select\"\r\n    [class.invalid]=\"!control?.valid && control?.touched\"\r\n    name=\"Country\"\r\n    (change)=\"writeValue($event.target.value)\"\r\n  >\r\n    <option value=\"\" selected hidden>\r\n      {{ 'country.options.none.selected' | translate: { fgbdefault: '--Select--' } }}\r\n    </option>\r\n    <option *ngFor=\"let country of countries\" [value]=\"country.CountryName\" [selected]=\"country.CountryName === innerValue\">\r\n      {{ country.DisplayName }}\r\n    </option>\r\n  </select>\r\n  <label for=\"select-country\" *ngIf=\"label\">{{ label }}</label>\r\n</div>\r\n", styles: [":host{width:inherit}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DEFAULT_COUNTRY]
                }] }, { type: i1.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2.CountryService }, { type: i2.CountryQuery }], propDecorators: { label: [{
                type: Input
            }], countryChange: [{
                type: Output
            }] } });

class SelectCountryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCountryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SelectCountryModule, declarations: [SelectCountryComponent], imports: [CommonModule,
            FGBSharedModule], exports: [SelectCountryComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCountryModule, imports: [CommonModule,
            FGBSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCountryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SelectCountryComponent
                    ],
                    imports: [
                        CommonModule,
                        FGBSharedModule
                    ],
                    exports: [
                        SelectCountryComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SelectCountryComponent, SelectCountryModule };
